import { GtmTracker } from '@/modules/common/services/analytics';
import { Categories } from '@/types/models/Analytics';

const { trackEvent, trackerWithDefaultProps } = GtmTracker;

const trackAmplitudeEvent = trackerWithDefaultProps({
  page_screen: 'home_portfolio',
  digital_experience: 'investor',
  experience_section: 'portfolio'
});

export function trackLoadWalletBuilderSelection() {
  trackAmplitudeEvent({
    event_type: 'load',
    event_name: 'view'
  });
}

export function trackCreateWalletReceiveSuggestion() {
  trackEvent({
    category: 'PEX',
    action: 'Carteira Sugerida',
    label: 'Criar Nova Carteira'
  });
  trackAmplitudeEvent({
    event_type: 'click',
    page_screen_section: 'body',
    event_name: 'create_suggested_portfolio'
  });
}

export function trackAdvancedWallet() {
  trackEvent({
    category: Categories.Wealth,
    action: 'Carteira Avançada',
    label: 'Criar Nova Carteira'
  });
  trackAmplitudeEvent({
    event_type: 'click',
    page_screen_section: 'body',
    event_name: 'create_advanced_portfolio'
  });
}
